import { JiraEntitlementAri } from '@atlassian/ari/jira/entitlement';

export const getEntitlementIdFromAri = (maybeAri: string): string =>
	JiraEntitlementAri.check(maybeAri) ? JiraEntitlementAri.parse(maybeAri).entitlementId : maybeAri;
